<app-entity-mat-dialog-title title="Activity History"></app-entity-mat-dialog-title>

<div mat-dialog-content class="activity-content" #scrollContainer>
  <!-- Filter Section -->
  <div class="filter-section">
    <mat-form-field appearance="outline" class="filter-select">
      <mat-label>Filter</mat-label>
      <mat-select [(value)]="selectedType" (selectionChange)="onFilterChange()">
        <mat-option *ngFor="let type of activityTypes" [value]="type.value">
          {{ type.label }}
        </mat-option>
      </mat-select>
    </mat-form-field>
    <button mat-icon-button (click)="refresh()" matTooltip="Refresh">
      <mat-icon>refresh</mat-icon>
    </button>
  </div>

  <div class="activity-list-wrapper">
    <!-- Loading State -->
    <div *ngIf="loading && activities.length === 0" class="loading-container">
      <mat-progress-spinner mode="indeterminate" diameter="50"></mat-progress-spinner>
      <p>Loading activities...</p>
    </div>

    <!-- Error State -->
    <div *ngIf="error && !loading" class="error-container">
      <mat-icon>error_outline</mat-icon>
      <p>{{ error }}</p>
      <button mat-raised-button color="primary" (click)="refresh()">Try Again</button>
    </div>

    <!-- Activity List -->
    <div *ngIf="!loading && !error" class="activity-list-container">
      <div class="activity-grid">
        <div class="activity-card" *ngFor="let activity of getFilteredActivities()">
          <div class="activity-card-header">
            <div class="activity-icon" [ngClass]="getIconColorClass(activity.type)">
              <mat-icon>{{ getIcon(activity.type) }}</mat-icon>
            </div>
            <div class="activity-info">
              <h4 class="activity-title">{{ activity.title }}</h4>
              <p class="activity-time">{{ activity.time_ago }}</p>
            </div>
          </div>
          <div class="activity-card-body">
            <p class="activity-description">{{ activity.description }}</p>
          </div>
        </div>
      </div>

      <!-- Loading More Indicator (for endless scroll) -->
      <div class="loading-more-container" *ngIf="loadingMore">
        <mat-progress-spinner mode="indeterminate" diameter="30"></mat-progress-spinner>
        <span>Loading more activities...</span>
      </div>

      <!-- Empty State -->
      <div *ngIf="!loading && !loadingMore && getFilteredActivities().length === 0" class="empty-state">
        <mat-icon>inbox</mat-icon>
        <h3>No Activities Found</h3>
        <p>No activities match your current filter.</p>
      </div>

      <!-- End of Results -->
      <div class="end-of-results" *ngIf="!hasMore && getFilteredActivities().length > 0 && !loadingMore">
        <p>No more activities to load</p>
      </div>
    </div>
  </div>
</div>

<mat-dialog-actions align="end">
  <button type="button" mat-button mat-dialog-close>Close</button>
</mat-dialog-actions>
